import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CompanyResolver } from 'src/app/shared/resolvers/company.resolver';
import { TeamRolesComponent } from './team-role/team-roles/team-roles.component';
import { TeamsComponent } from './team/teams/teams.component';
import { ProjectsComponent } from './project/projects/projects.component';
import { ManageProjectComponent } from './project/manage-project/manage-project.component';
import { ProjectInsightComponent } from './project-insight/project-insight.component';
import { MilestonesComponent } from './milestone/milestones/milestones.component';
import { TasksComponent } from './task/tasks/tasks.component';
import { TeamInsightComponent } from './team-insight/team-insight.component';
import { MilestoneInsightComponent } from './milestone-insight/milestone-insight.component';
import { ResourceInsightComponent } from './resource-insight/resource-insight.component';
import { ManageTeamComponent } from './team/manage-team/manage-team.component';
import { ManageMilestoneComponent } from './milestone/manage-milestone/manage-milestone.component';

const routes: Routes = [
  {
    path: 'teams',
    component: TeamsComponent,
    resolve: { companyId: CompanyResolver },
    data: { title: 'teams' }
  },
  {
    path: 'team-roles',
    component: TeamRolesComponent,
    resolve: { companyId: CompanyResolver },
    data: { title: 'Team Roles' }
  },
  {
    path: 'projects',
    component: ProjectsComponent,
    resolve: { companyId: CompanyResolver },
    data: { title: 'Projects' }
  },
  {
    path: 'manage-project',
    component: ManageProjectComponent,
    resolve: { companyId: CompanyResolver },
    data: { title: 'Manage-Projects' }
  },
  {
    path: 'project-insight',
    component: ProjectInsightComponent,
    resolve: { companyId: CompanyResolver },
    data: { title: 'Project-Insight' }
  },
  {
    path: 'milestones',
    component: MilestonesComponent,
    resolve: { companyId: CompanyResolver },
    data: { title: 'milestones' }
  },
  {
    path: 'tasks',
    component: TasksComponent,
    resolve: { companyId: CompanyResolver },
    data: { title: 'tasks' }
  },
  {
    path: 'team-insight',
    component: TeamInsightComponent,
    resolve: { companyId: CompanyResolver },
    data: { title: 'Team Insight' }
  },
  {
    path: 'milestone-insight',
    component: MilestoneInsightComponent,
    resolve: { companyId: CompanyResolver },
    data: { title: 'Milestone Insight' }
  },
  {
    path: 'resource-insight',
    component: ResourceInsightComponent,
    resolve: { companyId: CompanyResolver },
    data: { title: 'Resource Insight' }
  },
  {
    path: 'manage-team',
    component: ManageTeamComponent,
    resolve: { companyId: CompanyResolver },
    data: { title: 'Manage Team' }
  }, {
    path: 'manage-milestone',
    component: ManageMilestoneComponent,
    resolve: { companyId: CompanyResolver },
    data: { title: 'Manage Milestone' }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProjectPilotRoutingModule { }
